import Immutable from 'seamless-immutable'
import _ from 'lodash'

import * as authenticationActions from 'external/reduxBits/authentication/actions'
import * as actions from './actions'

const initialState = Immutable.from({
  isCreating: false,
  isDeleting: false,
  isFetching: false,
  hasFetched: false,
  error: false,
  errorId: null,
  errorType: null,
  ads: [],
  totalCount: 0,
  showOnlyActive: false,
})

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case authenticationActions.LOGOUT:
      return initialState

    case actions.REQUEST_CREATE_SAVED_AD:
      return state.merge({
        isCreating: true,
        error: false,
      })

    case actions.RECEIVE_CREATE_SAVED_AD:
      if (error) {
        return state.merge({
          isCreating: false,
          error: true,
          errorId: 'default',
          errorType: payload.errorType,
        })
      }
      return state.merge({
        ads: [payload, ...state.ads],
        isCreating: false,
      })

    case actions.RESET_SAVE_AD_ERROR:
      return state.merge({
        isCreating: false,
        error: false,
        errorType: null,
      })

    case actions.REQUEST_DELETE_SAVED_AD:
      return state.merge({
        isDeleting: true,
        error: false,
      })

    case actions.RECEIVE_DELETE_SAVED_AD:
      if (error) {
        return state.merge({
          isDeleting: false,
          error: true,
          errorId: 'default',
        })
      }
      return state.merge({
        ads: _.reject(state.ads, (o) => o.adId === payload.adId),
        isDeleting: false,
      })

    case actions.REQUEST_SAVED_ADS:
      return state.merge({
        isFetching: true,
        error: false,
      })

    case actions.RECEIVE_SAVED_ADS:
      if (error) {
        return state.merge({
          error: true,
          errorId: 'default',
        })
      }
      return state.merge({
        isFetching: false,
        hasFetched: true,
        ads: payload.data,
        totalCount: payload.totalCount,
      })

    case actions.SET_SAVED_ADS_SHOW_ONLY_ACTIVE:
      return state.set('showOnlyActive', payload)

    default:
      return state
  }
}
